export default __webpack_public_path__ + "static/media/agregar-dinero-tiendas.0da8ab78.png";